import React, { useState, useContext } from 'react';

import { observer } from 'mobx-react';
import { useStore } from '../../sdo.js'
import {useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import sso from "../../sso";

function Red_Menu(props) {
    var navigate = useNavigate();
    let [state, setState] = useState({row: {}, htitle: "", ma: []});
    let ctx = useStore();

    var lock = "lock";
    var moa = {};
    moa["f00"] = { fid: "f00", name: "Översikt", url: "/red", icon: "home", fa: "fa fa-home flex", ma: [] };
    moa["f01"] = { fid: "f01", name: "Ekonomi", url: "/red/eko", icon: "desktop", fa: "fa fa-desktop flex", ma: [] };
    moa["f02"] = { fid: "f02", name: "Hotell", url: "/red/pms", icon: "bars", fa: "fa fa-bars flex", ma: [] };
    moa["f03"] = { fid: "f03", name: "Kassa", url: "/red/pos", icon: "users", fa: "fa fa-users flex", ma: [] };
    moa["f04"] = { fid: "f04", name: "Faktura", url: "/red/fakt", icon: "list-alt", fa: "fa fa-list-alt flex", ma: [] };
    moa["f06"] = { fid: "f06", name: "Register", url: "/red/reg", icon: "wrench", fa: "fa fa-wrench flex", ma: [] };
    moa["f07"] = { fid: "f07", name: "Backoffice", url: "/red/bo", icon: "cogs", fa: "fa fa-cogs flex", ma: [] };

    moa["f01"].ma.push( { fid: "m01", name: "Period", url: "/red/eko/period", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "m01", name: "Dagrapport", url: "/red/eko/dr", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "m03", name: "Konto", url: "/red/eko/konto", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "m04", name: "Kassa", url: "/red/eko/kassa", fa: "fa fa-bars" } );

    moa["f02"].ma.push( { fid: "m01", name: "Period", url: "/red/pms/period", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "m02", name: "Dagrapport", url: "/red/pms/dr", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "m03", name: "Transaktioner", url: "/red/pms/trs", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "m04", name: "Rumsaldon", url: "/red/pms/saldo", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "m05", name: "Krubba", url: "/red/pms/krubba", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "m06", name: "Kreditkort", url: "/red/pms/cc", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "m07", name: "Kassa", url: "/red/pms/kassa", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "m08", name: "Bokat", url: "/red/pms/bokat", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "m09", name: "Gäster", url: "/red/pms/gst", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "m10", name: "Deltagare", url: "/red/pms/deltagare", fa: "fa fa-bars" } );

    moa["f03"].ma.push( { fid: "m01", name: "Period", url: "/red/pos/period", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "m02", name: "Dagrapport", url: "/red/pos/dr", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "m03", name: "Konto", url: "/red/pos/konto", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "m04", name: "Transaktioner", url: "/red/pos/trs", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "m05", name: "Hotelltransfer", url: "/red/pos/hotel", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "m06", name: "Kreditkort", url: "/red/pos/cc", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "m07", name: "Kassa", url: "/red/pos/kassa", fa: "fa fa-bars" } );

    moa["f04"].ma.push( { fid: "m01", name: "Reskontra", url: "/red/fakt/rsk", fa: "fa fa-list-ul" } );
    moa["f04"].ma.push( { fid: "m02", name: "Rapporter", url: "/red/fakt/rps", fa: "fa fa-suitcase" } );
    moa["f04"].ma.push( { fid: "m03", name: "Kunder", url: "/red/fakt/kund", fa: "fa fa-list-alt" } );

    moa["f06"].ma.push( { fid: "m01", name: "Hotell", url: "/red/reg/pms", fa: "fa fa-list-ul" } );
    moa["f06"].ma.push( { fid: "m02", name: "Kassa", url: "/red/reg/pos", fa: "fa fa-suitcase" } );

    moa["f07"].ma.push( { fid: "m01", name: "Konto", url: "/red/bo/konto", fa: "fa fa-bars" } );

    var aa = [];
    var keys = Object.keys(moa);
    for(var key of keys) {
        var o = moa[key];
        aa.push( o );
    }

    var ma = [];
    var mnuHeight = window.innerHeight - 100;

   function fknGo(row) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    var fkn = row.fid;
    setState({ mnu : row.fid, row : row,  ma : [] });
    ctx.fid = fkn;

       sso.seo.sfkn = row;
    //props.store.fkn = row;
       navigate(row.url);
   };
   function fknFix(fkn) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    ctx.fid = fkn;

    if(fkn == "lock") navigate('/web');
    if(fkn == "logout") navigate('/');
   };
   function mnuGo(row) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    //ctx.fid = fkn;
    setState({ mnu : state.hfid, row : state.row,  ma : [] });

       sso.seo.sfkn = row;
    //props.store.fkn = row;
       navigate(row.url);
   };
   function hideMnu() {
    setState({mnu : state.mnu, row : state.row, ma : [] });
   };
   function mouseEnter(it) {
    setState({mnu : state.mnu, row : state.row, hfid : it.fid, htitle : it.name, ma : it.ma });
   };
   function mouseLeave() {
    setState({mnu : state.mnu, row : state.row, ma : [] });
   };

   function row_css(row) {
  	    var css = {};
        css.margin = "0px";
        css.padding = "0px";
        css.height = "55px";
        css.borderBottom = "1px #ccc solid";

		if(state.mnu == row.fid) {
			css.background = "#080";
			css.color = "#fff";
		}
		return css;
    }
   function row_icon_css(row) {
  	    var css = {};
        css.paddingTop = "10px";
        css.fontSize = "20px";

		if(state.mnu == row.fid) {
			//css.color = "#ff9900";
			css.color = "#fff";
		}
		return css;
    }

   //<Icon className={ it.fa } style={{ fontSize: 18 }} />
   var html =
        <div className="">
        <div className="cdi_xmnu flex-fullcol" style={{padding: "5px 0px"}}>
            { aa.map((it, key) =>
            <div key={ key } onClick={() => fknGo(it)} className="web-col flex-cc xmnu_tab" style={ row_css(it) } onMouseEnter={ () => mouseEnter(it) }>
                <FontAwesomeIcon icon={ it.icon } size="1x" className="flex" style={ row_icon_css(it) } />
                <div style={{fontSize: "10px"}}>{ it.name }</div>
            </div>
            )}
            <div onClick={ () => fknFix("lock") } className="web-col flex-cc xmnu_tab">
                <FontAwesomeIcon icon="lock" size="1x" className="flex" style={{paddingTop: "10px", fontSize: "20px"}} />
                <div style={{fontSize: "10px"}}>Lås</div>
            </div>
            <div onClick={() => fknFix("logout") } className="web-col flex-cc xmnu_tab" >
                <i className="fa fa-power-off flex" aria-hidden="true" style={{paddingTop: "10px", fontSize: "20px"}}></i>
                <div style={{fontSize: "10px"}}>Logga ur</div>
            </div>
        </div>

            { state.ma.length ?
        <div className="mtrl_mnu_sub mtrl_mnu_bg" aria-label="Sub Menu" style={{height: mnuHeight}} onMouseLeave={mouseLeave}>
          <div className="mtrl_mnu_title" onClick={() => hideMnu()}>
            { state.htitle }
          </div>
            { state.ma.map((mi, key) =>
          <div key={key} className="mtrl_mnu_item flex-row" onClick={ () => mnuGo(mi) }>
            <div className="flex">{ mi.name }</div>
            <i className={ mi.fa } aria-hidden="true" style={ row_icon_css(mi) }></i>
          </div>
            )}
        </div>
                : null }
        </div>
    ;
    return html;
}

export default observer(Red_Menu);
